module.exports = __webpack_public_path__ + "static/media/ear_512x512.292394c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/ear_512x512.png
// module id = 77
// module chunks = 0